
import React, { useState, useEffect } from "react";
import axios from "../api/axios";
import Header from "../Components/Header";
import Hero from "../Layout/Hero";
import Category from "../Layout/Category";
import Prodcuts from "../Components/Products";
import SectionHeader from "../Components/SectionHeader";
import Rug from "../Layout/Rug";
import About from "../Layout/About";
import BestsellingProducts from "../Layout/BestsellingProducts";
import BgCta from "../Layout/BgCta";
import Testimonial from "../Layout/Testimonial";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";

function Home() {
  const [homeCategories, setHomeCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/categories/home')
      .then(response => {
        if (response.data && response.data.data) {
          setHomeCategories(response.data.data);
        }
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching home categories:", error);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <Header mode="light" />
      <Hero />

      <SectionHeader
        title="Shop By Category"
        subtitle="Discover premium fabrics, timeless designs, and comfort for every space."
      />

      <Category />

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-dark" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          {homeCategories.map((cat, index) => {
            const productSection = (
              <React.Fragment key={cat.id}>
                <SectionHeader
                  title={cat.name}
                  subtitle="Discover premium fabrics, timeless designs, and comfort for every space."
                />
                <Prodcuts categorySlug={cat.slug} />
              </React.Fragment>
            );

            // Interleave Rug section after the 2nd category (index 1)
            if (index === 1) {
              return (
                <React.Fragment key={cat.id}>
                  {productSection}
                  <SectionHeader
                    title="Rug By Room"
                    subtitle="Discover premium fabrics, timeless designs, and comfort for every space."
                  />
                  <Rug />
                </React.Fragment>
              );
            }

            return productSection;
          })}

          {/* If there are less than 2 categories, make sure Rug by Room is still shown */}
          {homeCategories.length < 2 && (
            <>
              <SectionHeader
                title="Rug By Room"
                subtitle="Discover premium fabrics, timeless designs, and comfort for every space."
              />
              <Rug />
            </>
          )}
        </>
      )}

      <About />
      <BestsellingProducts />
      <BgCta />
      <Testimonial />
      <Feature />
      <Footer />
    </>
  );
}

export default Home;
